import * as THREE from 'three';
import { BokehPass } from 'three/examples/jsm/postprocessing/BokehPass';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass';
import { Emitter } from '../core';
import Exp from './Exp';

export default class PostPro {
    constructor(isSet, focusValue) {
        this.experience = new Exp();
        this.scene = this.experience.scene;
        this.camera = this.experience.camera.instance;
        this.renderer = this.experience.renderer.instance;
        this.sizes = this.experience.sizes;
        this.renderTarget = new THREE.WebGLRenderTarget(
            this.sizes.width,
            this.sizes.height,
            {
                //Anti-aliasing for WebGL2
                samples: this.sizes.pixelRatio === 1 ? 2 : 0,
            }
        )
        if (isSet) {
            this.scene.background = new THREE.Color('#0e0e0e');
            this.renderer.alpha = false;
        }

        this.composer = new EffectComposer(
            this.renderer,
            this.renderTarget
        );
        this.composer.setSize(this.sizes.width, this.sizes.height);
        this.composer.setPixelRatio(this.sizes.pixelRatio);

        this.renderPass = new RenderPass(this.scene, this.camera);
        this.composer.addPass(this.renderPass);

        //Anti-aliasing for WebGL1
        if (this.renderer.getPixelRatio() === 1 && !this.renderer.capabilities.isWebGL2) {
            const smaaPass = new SMAAPass();
            this.composer.addPass(smaaPass);
            console.log('Using SMAA');
        }

        const bokehPass = new BokehPass(this.scene, this.camera, {
            aperture: 0.0012,
            maxblur: 0.1,
            width: this.experience.sizes.width,
            height: this.experience.sizes.height
        })
        bokehPass.uniforms['focus'].value = focusValue;
        bokehPass.enabled = true;
        this.composer.addPass(bokehPass);
    }

    resize() {
        this.composer.setSize(this.sizes.width, this.sizes.height);
        this.composer.setPixelRatio(this.sizes.pixelRatio);
    }

    update() {
        this.composer.render();
    }
}